module.exports = __webpack_public_path__ + "static/media/warning.8210f4a8.svg";